module.exports = __webpack_public_path__ + "img/growcify-website-7-banner.8039ce38.png";